// Settings Context - src/context/Settings
import { Backdrop, CircularProgress, Snackbar, Alert } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useContext, useState, useEffect } from 'react';

const useStyle = makeStyles(() => ({
    cargando: {
        zIndex: '900'
    }
}));
const LoginContext = React.createContext();

const Loginettings = localStorage.getItem('token') != '' ? { token: localStorage.getItem('token'), usuario: { areas: [] } } : false;

export const LoginProvider = ({ children, loginDefalult }) => {
    const classes = useStyle();
    const [login, setLogin] = useState(loginDefalult || Loginettings);
    const [cargando, setCargando] = useState(false);
    const [mensaje, setMensaje] = useState({ open: false, status: 0, value: '' });
    const cerrarMensaje = (event) => setMensaje({ ...mensaje, open: false });

    // Generar loginSessionId solo si no existe
    useEffect(() => {
        if (login && login.token) {
            // Solo generar si no existe ya un loginSessionId
            const existingSessionId = sessionStorage.getItem('loginSessionId');
            if (!existingSessionId) {
                const loginSessionId = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
                sessionStorage.setItem('loginSessionId', loginSessionId);
            } else {
            }
        }
    }, [login]);

    const cambioLogin = (values) => {
        // Generar un ID único de sesión SOLO si no existe
        let loginSessionId = sessionStorage.getItem('loginSessionId');

        if (!loginSessionId) {
            loginSessionId = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            sessionStorage.setItem('loginSessionId', loginSessionId);
        } else {
        }

        setLogin(values);
    };

    const cerrarLogin = () => {
        // sessionStorage.removeItem('videoMostrado');
        // Limpiar todo el sessionStorage al cerrar sesión
        sessionStorage.clear();
        localStorage.clear();
        setLogin(null);
        window.location = '/';
    };
    return (
        <>
            <Backdrop className={classes.cargando} open={cargando}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <LoginContext.Provider value={{ login: login, cambioLogin, cerrarLogin, bloqueo: setCargando, mensaje: setMensaje }}>
                {children}
            </LoginContext.Provider>
            <Snackbar open={mensaje.open} autoHideDuration={4000} onClose={cerrarMensaje}>
                <Alert
                    onClose={cerrarMensaje}
                    variant="filled"
                    severity={(mensaje.status < 0 && 'error') || (mensaje.status > 0 && 'success') || 'info'}
                >
                    {mensaje.value}
                </Alert>
            </Snackbar>
        </>
    );
};

export const Loginconsumer = LoginContext.Consumer;
export const useLogin = () => {
    const { login } = useContext(LoginContext);

    return { usuario: login?.usuario || {} };
};

export default LoginContext;
